import { format as formatDate } from "date-fns";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from "./resources/en";
import srTranslations from "./resources/sr";
import mkTranslations from "./resources/mk";
import seTranslations from "./resources/se";

i18n.use(initReactI18next).init({
  lng: "sr",
  fallbackLng: "sr",
  debug: false,
  supportedLngs: ["en", "sr", "mk", "se"],
  resources: {
    en: {
      translation: enTranslations,
    },
    sr: {
      translation: srTranslations,
    },
    mk: {
      translation: mkTranslations,
    },
    se: {
      translation: seTranslations
    }
  },
  interpolation: {
    format: (value, format) => {
      if (value instanceof Date) {
        return formatDate(value, format ?? "sr");
      }

      return value;
    },
  },
});

export default i18n;
